// Librerías externas
import React from 'react';
import ReactDOM from 'react-dom';

// Librería de Diseño / UI
import './index.css';

// Componentes internos de la aplicación
import App from './App';
import reportWebVitals from './reportWebVitals';

// Renderizar el componente App con React
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
